/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface PositionCenterProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const PositionCenter: React.FC<PositionCenterProps> = ({ color = 'none', ...props }) => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2498 12.3013C20.2498 11.8871 19.914 11.5513 19.4998 11.5513H4.5C4.08579 11.5513 3.75 11.8871 3.75 12.3013C3.75 12.7155 4.08579 13.0513 4.5 13.0513H19.4998C19.914 13.0513 20.2498 12.7155 20.2498 12.3013Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4696 10.2965C11.7624 10.5894 12.2373 10.5894 12.5302 10.2965L15.673 7.15376C15.9659 6.86087 15.9659 6.38599 15.673 6.0931C15.3801 5.8002 14.9053 5.8002 14.6124 6.09309L11.9999 8.70553L9.38745 6.09309C9.09455 5.8002 8.61968 5.8002 8.32679 6.09309C8.03389 6.38599 8.03389 6.86086 8.32679 7.15375L11.4696 10.2965Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.94507C11.5858 9.94507 11.25 9.60928 11.25 9.19507L11.25 1.71533C11.25 1.30112 11.5858 0.965332 12 0.965332C12.4142 0.965332 12.75 1.30112 12.75 1.71533V9.19507C12.75 9.60928 12.4142 9.94507 12 9.94507Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4696 13.8195C11.7625 13.5266 12.2374 13.5266 12.5303 13.8195L15.4387 16.7279C15.7316 17.0208 15.7316 17.4956 15.4387 17.7885C15.1458 18.0814 14.671 18.0814 14.3781 17.7885L12 15.4105L9.62188 17.7885C9.32899 18.0814 8.85412 18.0814 8.56122 17.7885C8.26833 17.4956 8.26833 17.0208 8.56122 16.7279L11.4696 13.8195Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.0538C11.5858 14.0538 11.25 14.3896 11.25 14.8038L11.25 22.2835C11.25 22.6978 11.5858 23.0335 12 23.0335C12.4142 23.0335 12.75 22.6978 12.75 22.2835V14.8038C12.75 14.3896 12.4142 14.0538 12 14.0538Z"
        fill={color}
      />
    </svg>
  );
};
